<template>
    <v-content>
        <!-- Parallax -->
        <section v-if="$vuetify.breakpoint.smAndUp" class="elevation-10">
            <v-parallax src="public/dividers/div_2.png" height="400">
                <v-layout column align-center justify-center class="white--text">
                    <div v-lang.webDes class="font-title text-xs-center"></div>
                </v-layout>
            </v-parallax>
        </section>
        <section v-else class="elevation-10">
            <v-parallax src="public/dividers/div_2_min.png" height="200">
                <v-layout column align-center justify-center class="white--text mt-5">
                    <div v-lang.webDes class="font-title-mobile text-xs-center"></div>
                </v-layout>
            </v-parallax>
        </section>
        <!-- Content -->
        <section>
            <v-layout column wrap class="mb-5">
                <v-container grid-list-xl>
                    <v-layout row wrap align-center>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0 transparent">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large class="light-blue--text">dashboard</v-icon>
                                </v-card-text>
                                <v-card-title primary-title class="layout justify-center">
                                    <div v-lang.webItem1 class="font-heading text-xs-center"></div>
                                </v-card-title>
                                <v-card-text v-lang.webItem1Des style="text-align: justify; min-height: 150px;"></v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0 transparent">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large class="lime--text text--lighten-1">trending_up</v-icon>
                                </v-card-text>
                                <v-card-title primary-title class="layout justify-center">
                                    <div v-lang.webItem2 class="font-heading text-xs-center"></div>
                                </v-card-title>
                                <v-card-text v-lang.webItem2Des style="text-align: justify; min-height: 150px;"></v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0 transparent">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large class="red--text text--darken-3">today</v-icon>
                                </v-card-text>
                                <v-card-title primary-title class="layout justify-center">
                                    <div v-lang.webItem3 class="font-heading text-xs-center"></div>
                                </v-card-title>
                                <v-card-text v-lang.webItem3Des style="text-align: justify; min-height: 150px;"></v-card-text>
                            </v-card>
                        </v-flex>
                        <!-- APP Carousel -->
                        <v-flex xs12 v-if="$vuetify.breakpoint.mdAndUp" class="my-4">
                            <carousel-3d display="3" :clickable="true" perspective="0" inverseScaling="0" space="300" width="854" height="480" border="0" :autoplay="true" :autoplay-timeout="3000">
                                <slide v-for="(slide, i) in slides" :index="i" :key="i" style="box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                                    <div id="carousel-img" v-bind:style="{ backgroundImage: 'url(' + slide.src + ')'}"></div>
                                </slide>
                            </carousel-3d>
                        </v-flex>
                        <!-- APP Images -->
                        <v-flex xs12 v-else>
                            <img src="public/images/WEB_Dash.png" class="mt-1" style="width: 100%; box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                            <img src="public/images/WEB_Schedules.png" class="mt-3" style="width: 100%; box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                            <img src="public/images/WEB_Stats.png" class="mt-3" style="width: 100%; box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.5)">
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0 transparent">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large class="teal--text text--lighten-1">bug_report</v-icon>
                                </v-card-text>
                                <v-card-title primary-title class="layout justify-center">
                                    <div v-lang.webItem4 class="font-heading text-xs-center"></div>
                                </v-card-title>
                                <v-card-text v-lang.webItem4Des style="text-align: justify; min-height: 150px;"></v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0 transparent">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large class="purple--text text--lighten-1">vertical_align_bottom</v-icon>
                                </v-card-text>
                                <v-card-title primary-title class="layout justify-center">
                                    <div v-lang.webItem5 class="font-heading text-xs-center"></div>
                                </v-card-title>
                                <v-card-text v-lang.webItem5Des style="text-align: justify; min-height: 150px;"></v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 md4>
                            <v-card class="elevation-0 transparent">
                                <v-card-text class="text-xs-center">
                                    <v-icon x-large class="deep-orange--text">developer_board</v-icon>
                                </v-card-text>
                                <v-card-title primary-title class="layout justify-center">
                                    <div v-lang.webItem6 class="font-heading text-xs-center"></div>
                                </v-card-title>
                                <v-card-text v-lang.webItem6Des style="text-align: justify; min-height: 150px;"></v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-layout>
        </section>
        <!-- Footer -->
        <c-footer></c-footer>
    </v-content>
</template>

<script>
import CFooter from "./Footer";
export default {
  data() {
    return {
      slides: [
        {
          src: "public/images/WEB_Dash.png"
        },
        {
          src: "public/images/WEB_Schedules.png"
        },
        {
          src: "public/images/WEB_Stats.png"
        }
      ]
    };
  },
  components: {
    CFooter
  }
};
</script>

<style>
#carousel-img {
  height: 100% !important;
  width: 100% !important;
  background-size: cover !important;
}

.carousel-3d-container {
  overflow: visible !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Web.vue